import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ACMRemote, ACMRemoteCreate } from '../../../shared/interfaces/equipment.interfaces';

const basePath = '/equipment/acm_remote';

@Injectable({
  providedIn: 'root',
})

export class EquipmentAcmRemoteService {

  constructor(private http: HttpClient) { }

  // Get all remotes for current dealer
  getACMRemotes(): Observable<ACMRemote[]> {
    return this.http.get<ACMRemote[]>(`${basePath}`);
  }

  // Add a new remote entry to dealer
  createACMRemote(body: ACMRemoteCreate): Observable<ACMRemote> {
    return this.http.post<ACMRemote>(`${basePath}`, body);
  }

  // Get remote by id
  getACMRemoteById(id: number): Observable<ACMRemote> {
    return this.http.get<ACMRemote>(`${basePath}/${id}`);
  }

  // Update remote
  updateACMRemote(ACMRemote: ACMRemote): Observable<ACMRemote> {
    const body = ACMRemote;
    return this.http.put<ACMRemote>(`${basePath}/${ACMRemote.id}`, body);
  }

  // Delete remote
  deleteACMRemote(id: number): Observable<ACMRemote> {
    return this.http.delete<ACMRemote>(`${basePath}/${id}`);
  }

  // Start/Stop ACM remotes discovery mode
  discoverACMRemotes(active: boolean): Observable<any> {
    const body = {
      "active": active
    }
    return this.http.post<any>(`${basePath}/pair`, body);
  }

}
